// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3J41E","subheader":"ReorderModal_subheader__Q3jcq","listWrap":"ReorderModal_listWrap__DiVk0"};